/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-invalid-this */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import {
  Box,
  Grid,
  Link,
  Dialog,
  Divider,
  TextField,
  Typography,
  DialogContent,
  DialogActions,
  FormHelperText,
  InputLabel,
  Autocomplete
} from '@mui/material';
import _ from 'lodash';
import * as Yup from 'yup';
import { rolesArray } from '../../../components/common';
import { ValidationError } from 'yup';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { API } from '../../../../../api';
import { useParams, useLocation } from 'react-router-dom';
import Upvotes from '../../../components/Upvotes';
import { yupResolver } from '@hookform/resolvers/yup';
import { useModule } from '../../../../../utils/useModule';
import ChatAvatarComponent from '../../chat/ChatAvatarComponent';
import countryCodeArray from '../../../../../constants/countrycode';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { Controller, SubmitHandler, FieldValues, useForm } from 'react-hook-form';
import { validatePhoneNumber } from '../../../../../constants/PhoneNumberValidator';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import { fetchGroupUsers, groupUsersActions } from '../../../../../redux/slices/group-users/groupUsersSlice';
import { useProgramCreation } from '../../../../../components/admin3/newProgram/ProgramCreationContext';
import DosenInput from '../../../components/DosenInput';
import DosenDropdown from '../../../components/DosenDropdown';
import DosenButton from '../../../../../components/ui/Buttons/DosenButton';
import { eventTracking, events, attributeKeys } from '../../../../../utils/amplitude';
import DosenAutocomplete from '../../../components/DosenAutocomplete';
import { MemberRole, isMemberRole, useMemberWord } from '../../../../../utils/memberTypeLabels';
// import { useProgramCreation } from '../../../../../../components/admin3/newProgram/ProgramCreationContext';

interface Props {
  handleClose: any;
  data?: any;
  openDialog: boolean;
  setOpenDialog: any;
  type: string;
}

// Role options keep their values ('Mentee', 'Mentor', 'Admin' go to the API); only the label is the org's word.
const roleLabel = (option: string, w: ReturnType<typeof useMemberWord>) =>
  isMemberRole(option) ? w(option.trim().toLowerCase() as MemberRole) : _.startCase(option);

interface CountryType {
  name: string;
  dial_code: string;
  code: string;
}
interface SelectedValue {
  groupId: any;
  groupName: string;
  userRole: any;
}

const InviteUserDialog = ({ handleClose, data, openDialog, setOpenDialog, type }: Props) => {
  const params = useParams<{ id?: string; orgId?: string }>();
  const location = useLocation();
  const urlGrpId = params.id || '';
  const orgId = params.orgId || '';
  const { state } = useProgramCreation();
  const isCreationFlow = location.pathname.includes('/new-program');
  const grpId = state.groupId || urlGrpId;
  const [inviteUserLoading, setInviteUserLoading] = useState(false);
  const dispatch = useAppDispatch();
  const orgDisplayName = useAppSelector((state) => state.orgDetails.data?.name);
  const groupUsers = useAppSelector((state) => state.groupUsers.data?.users);
  const invitedUsers = useAppSelector((state) => state.groupUsers.data?.invitedUsers);
  const w = useMemberWord();
  const allGroupsData = useAppSelector((state: any) => state.groupData?.groups || []);
  // Not this program, and no program for its roles only: its learners join through their roles, never by
  // invitation (the backend refuses it). GET {orgId}/group/{grpId}/getAllGroupsList does not send roleIds
  // yet: until it does, such a program is still listed here, and the backend's refusal is shown.
  const updatedGroupsData = allGroupsData.filter(
    (group: any) => group.grpId !== grpId && !(Array.isArray(group.roleIds) && group.roleIds.length > 0)
  );
  const [roleData, setRoleData] = useState([]);
  const isGoal = useAppSelector((state) => state.groupDetails.data?.goalPublished);

  const groupsDataStructure = updatedGroupsData.map(
    (group: { grpId: any; name: any; logo: any; enrolledCount: any; displayRoles: any; settingsUpdate: boolean }) => ({
      id: group.grpId,
      name: group.name,
      logo: group.logo,
      enrolled: group.enrolledCount,
      displayRoles: group.displayRoles,
      settingsUpdate: group.settingsUpdate
    })
  );

  const [selectedGroups, setSelectedGroups] = useState<
    {
      enrolled: any;
      logo: any;
      id: any;
      name: string;
      displayRoles: any;
      settingsUpdate: boolean;
    }[]
  >([]);

  const [availableGroups, setAvailableGroups] = useState(groupsDataStructure);
  const [selectedValues, setSelectedValues] = useState<SelectedValue[]>([]);
  const [removeGroupId, setRemoveGroupId] = useState();
  const selectedGroupsInfo = selectedValues.map((group) => ({
    grpId: group.groupId,
    role: group.userRole
  }));

  const { isMasterclass, isHybrid, isMentorship } = useModule();
  const addUsersdetails = Yup.object({
    firstName: Yup.string()
      .required('First name is required')
      .test('no-empty-spaces', 'First name cannot be all empty spaces', (value) => {
        if (value) {
          return !/^[\s]+$/.test(value);
        }
        return true;
      })
      .min(1, 'Name must be at least 1 character')
      .max(25, 'Maximum 25 characters'),
    lastName: Yup.string()
      .required('Last name is required')
      .test('no-empty-spaces', 'Last name cannot be all empty spaces', (value) => {
        if (value) {
          return !/^[\s]+$/.test(value);
        }
        return true;
      })
      .min(1, 'Name must be at least 1 character')
      .max(25, 'Maximum 25 characters'),
    email: Yup.string()
      .transform((value) => value.trim())
      .matches(/^[A-Za-z0-9]/, 'Email must start with either Alphabet or number')
      .required('Email is required')
      .email('Email must be a valid email'),
    role: Yup.string().required('Role is required'),
    // mobileNumber: Yup.string().matches(
    //   /^(\d{10})?$/,
    //   "Enter 10 digit Mobile Number or be it Empty"
    // ),
    mobileNumber: Yup.string()
      .transform((value) => value.trim())
      .test('is-valid-phone-number', 'Invalid phone number', async function (value) {
        if (!value) {
          // Return true for empty phone number
          return true;
        }
        const { path, createError } = this;
        const validationResult = await validatePhoneNumber(value, selectedCountry);
        if (validationResult) {
          const { isValid, error } = validationResult;
          return isValid || createError({ path, message: error } as ValidationError);
        }
        return createError({
          path,
          message: 'Validation error'
        } as ValidationError);
      })
    // group: Yup.array()
    //   .of(
    //     Yup.object({
    //       // id: Yup.number().required('Group ID is required'),
    //       name: Yup.string().required('Group Name is required'),
    //     })
    //   )
    //   .min(1, 'Group is required')
    //   .required('Group is required'),
  });

  selectedGroups.forEach(({ id, name }: any) => {
    const userRole = `groupUserRole_${id}`;
    (addUsersdetails.fields as any)[userRole] = Yup.mixed()
      .transform((value, originalValue) => (originalValue === null ? undefined : value))
      .nullable()
      .when(['role'], (roleFieldValue, schema) => {
        return schema.test('is-required', `Role is required`, (value: string | any[]) => {
          return (Array.isArray(value) && value.length > 0) || typeof value === 'string';
        });
      });
  });

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    reset
  } = useForm({
    resolver: yupResolver(Yup.object(addUsersdetails.fields))
  });

  const selectedCountryObject =
    data && data.phonePrefix ? countryCodeArray.find((country) => country.dial_code === data.phonePrefix) : null;
  // const [selectedCountry, setSelectedCountry] = React.useState<CountryType | null>(countryCodeArray[0] || null);
  const [selectedCountry, setSelectedCountry] = React.useState<CountryType | null>(selectedCountryObject || null);
  const handleCountryChange = (value: CountryType | null) => {
    setSelectedCountry(value);
  };

  const onSubmit: SubmitHandler<FieldValues> = async (values) => {
    setInviteUserLoading(true);
    const formData = {
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      role: [values.role],
      email: values.email.trim(),
      mobileNumber: values.mobileNumber ? values.mobileNumber.trim() : values.mobileNumber,
      // phonePrefix: selectedCountry,
      phonePrefix: selectedCountry?.dial_code,
      groups: selectedGroupsInfo
    };
    if (values.mobileNumber && selectedCountry) {
      const phoneNumberValidationResult = await validatePhoneNumber(values.mobileNumber, selectedCountry);
      if (phoneNumberValidationResult && !phoneNumberValidationResult.isValid) {
        // Handle invalid phone number...
        // console.log("Invalid phone number");
        return;
      }
    }

    try {
      const response = await API.inviteUserToAGroup({
        formData,
        orgId,
        grpId
      });

      if (response?.status === 200) {
        if (response.data.userDetails) {
          const index = groupUsers?.findIndex((each) => each.userId === response.data.userDetails?.userId);
          if (index !== -1) {
            dispatch(groupUsersActions.updateUser(response.data.userDetails));
          } else {
            dispatch(groupUsersActions.updateGroupUsers(response.data.userDetails));
          }
        } else if (type === 'Add' && response.data.invitedUser) {
          const invitedIndex = invitedUsers?.findIndex(
            (each) => each.userId === response.data.invitedUser?.userId
          );
          if (invitedIndex !== undefined && invitedIndex !== -1) {
            dispatch(groupUsersActions.updateInvitedUser(response.data.invitedUser));
          } else {
            dispatch(groupUsersActions.updateGroupInvitedUsers(response.data.invitedUser));
          }
        } else if (response.data.invitedUser) {
          dispatch(groupUsersActions.updateInvitedUser(response.data.invitedUser));
        }
        const refetchIds = new Set<string>(
          [String(grpId || ''), ...selectedValues.map((g) => String(g.groupId || ''))].filter(Boolean)
        );
        refetchIds.forEach((gId) => {
          dispatch(fetchGroupUsers({ grpId: gId, pageNumber: 1, pageSize: 50 }));
        });
        const invitedProgramNames = selectedValues.map((g) => g.groupName).filter(Boolean).join(', ');
        eventTracking(events.userInvited, {
          [attributeKeys.userEmail]: values.email.trim(),
          [attributeKeys.organizationName]: orgDisplayName || '',
          [attributeKeys.programName]: invitedProgramNames,
          [attributeKeys.enrollmentType]: 'Manual Invite',
          inviteeRole: String(values.role || '')
        });
        toast.success('Invitation sent successfully');
      }
    } catch (error) {
      toast.error(_.get(error, 'response.data.message', 'Somthing went wrong'));
      setInviteUserLoading(false);
    } finally {
      handleCloseDialog();
      reset();
      setInviteUserLoading(false);
      setSelectedValues([]);
      handleClose();
    }
  };

  const checkError = (fieldName: string) => Boolean(errors[fieldName]);
  const getError = (fieldName: string) => errors[fieldName]?.message;
  const roleOptions: any[] = rolesArray();
  const roleDropdownOptions = useMemo(() => {
    const filteredRoles = isMasterclass
      ? roleOptions.filter((option) => option?.toLowerCase?.() !== 'mentor')
      : roleOptions;
    return filteredRoles.map((option) => ({
      value: option,
      label: roleLabel(option, w)
    }));
  }, [roleOptions, isMasterclass, w]);

  const handleAutocompleteChange = (groupId: any, groupName: string, newValue: any) => {
    const updatedValues = [...selectedValues];
    const index = updatedValues.findIndex((item) => item.groupId === groupId);

    if (index !== -1) {
      updatedValues[index].userRole = newValue;
    } else {
      updatedValues.push({ groupId, groupName, userRole: newValue });
    }
    setSelectedValues(updatedValues);
  };

  const handleGroupChange = (
    event: React.SyntheticEvent,
    newValues: { id: any; name: string; logo: any; enrolled: any; displayRoles: any; settingsUpdate: boolean }[]
  ) => {
    setValue(`groupUserRole_${removeGroupId}`, []);
    setSelectedGroups(newValues);
  };

  const handleRemoveGroup = (groupId: any) => {
    setRemoveGroupId(groupId);
    setValue(`groupUserRole_${groupId}`, []);
    // const removedGroup = selectedGroups.find((group) => group.id === groupId) as {
    //   id: any;
    //   name: string;
    //   logo: any;
    //   enrolled: any;
    // };
    //setAvailableGroups((prevAvailableGroups: any) => [...prevAvailableGroups, removedGroup]);
    const updatedGroups = selectedGroups.filter((group) => group.id !== groupId);
    setSelectedGroups(updatedGroups);
    const updatedValues = selectedValues.filter((item) => item.groupId !== groupId);
    setSelectedValues(updatedValues);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    reset();
    setSelectedGroups([]);
    setAvailableGroups(groupsDataStructure);
  };

  useEffect(() => {
    const isAdd = type?.toLowerCase?.() === 'add';
    if (isAdd || !data?.groups) {
      reset();
      setSelectedValues([]);
    } else {
      const normalizedData = {
        ...data,
        role: Array.isArray(data?.role) ? data.role[0] : data?.role || ''
      };
      reset(normalizedData);
      setRoleData(data);
      const groupIds = (data.groups || []).map((group: { grpId: any }) => group.grpId);
      const groupsToSelect = availableGroups.filter((group: { id: any }) => groupIds.includes(group.id));
      setValue('group', groupsToSelect);
      setSelectedGroups(groupsToSelect);
      const selectedGroupsInfo = (data.groups || []).map((group: { grpId: any; role: any }) => ({
        groupId: group.grpId,
        userRole: group.role
      }));
      setSelectedValues(selectedGroupsInfo);
    }
  }, [openDialog]);

  /** 19Dec/2023: New group row design */
  const GroupRow: React.FC<{
    groupId: number;
    groupName: string;
    groupLogo: any;
    groupEnrolled: any;
    isLast: boolean;
    displayRoles: any;
    settingsUpdate: boolean;
  }> = ({ groupId, groupName, groupLogo, groupEnrolled, isLast, displayRoles, settingsUpdate }) => {
    const userRole = `groupUserRole_${groupId}`;
    let displayRolesArrayForSpecificGroup: (string | undefined)[] =
      (
        roleData as { groups?: { grpId: number; role: (string | undefined)[]; displayRoles: { [x: string]: any } }[] }
      )?.groups
        ?.filter((group) => group.grpId === groupId)
        .map((group) => group.role)?.[0] ?? [];

    if (displayRolesArrayForSpecificGroup.length > 0) {
      displayRolesArrayForSpecificGroup = displayRolesArrayForSpecificGroup
        .filter((role): role is string => typeof role === 'string' && role.trim() !== '')
        .map((role) => _.startCase(role))
        .filter((role): role is string => typeof role === 'string');
    } else {
      displayRolesArrayForSpecificGroup = [];
    }

    let transformedArray = displayRolesArrayForSpecificGroup;
    console.log(displayRoles);

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Box display="flex" gap="8px">
              <Box>
                <ChatAvatarComponent
                  image={groupLogo}
                  type="noStatus"
                  firstLetter={(groupName || '').charAt(0).toUpperCase()}
                  width="50px"
                  height="50px"
                />
              </Box>
              <Box width="calc(100% - 58px)">
                <Box display="flex" alignItems="center" justifyContent="space-between" gap="5px">
                  <Typography variant="h5" noWrap>
                    {groupName}
                  </Typography>
                </Box>
                <Box pt={1}>
                  <Upvotes number={groupEnrolled} icon="group" />
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box>
              <InputLabel>Role*</InputLabel>
              <Controller
                name={userRole}
                control={control}
                defaultValue={transformedArray}
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    multiple
                    options={settingsUpdate ? roleOptions : ['Admin']}
                    getOptionLabel={(option) => roleLabel(option, w)}
                    value={value}
                    id={userRole}
                    onChange={(event, newValue) => {
                      handleAutocompleteChange(groupId, groupName, newValue);
                      onChange(newValue);
                    }}
                    disableCloseOnSelect
                    renderInput={(params) => <TextField {...params} fullWidth placeholder="Select Role" />}
                  />
                )}
              />
              <FormHelperText error={!!errors[`groupUserRole_${groupId}`]?.message}>
                {errors[`groupUserRole_${groupId}`]?.message as ReactNode}
              </FormHelperText>
            </Box>
            <Box display="flex" justifyContent="end" width="100%">
              <Link color="error" fontSize="10px" fontWeight="600" onClick={() => handleRemoveGroup(groupId)}>
                Remove
              </Link>
            </Box>
          </Grid>
        </Grid>
        {!isLast && <Divider sx={{ my: 2 }} />}
      </>
    );
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      scroll="body"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#1C1C1C',
          backgroundImage: 'none',
          border: '1px solid #2A2A2A',
          borderRadius: '8px',
          color: '#FDFDFD'
        }
      }}
    >
      <CommonModalHeader
        // eslint-disable-next-line react/jsx-curly-brace-presence
        title={'Invite people'}
        //title={type === 'Add' ? 'Add User' : 'Invite User'}
        handleCloseModal={handleCloseDialog}
      />
      <DialogContent style={{ backgroundColor: 'transparent' }}>
        <Grid container spacing={2}>
          {/* First Name */}
          <Grid item xs={12} sm={6}>
            <Controller
              name="firstName"
              control={control}
              render={({ field: { onChange, value } }) => (
                <DosenInput
                  label="First name *"
                  type="text"
                  value={value || ''}
                  placeholder="John"
                  onChange={onChange}
                  fullWidth
                  error={checkError('firstName')}
                  helperText={getError('firstName')?.toString()}
                />
              )}
            />
          </Grid>

          {/* Last Name */}
          <Grid item xs={12} sm={6}>
            <Controller
              name="lastName"
              control={control}
              render={({ field: { onChange, value } }) => (
                <DosenInput
                  label="Last name *"
                  type="text"
                  value={value || ''}
                  placeholder="Smith"
                  onChange={onChange}
                  fullWidth
                  error={checkError('lastName')}
                  helperText={getError('lastName')?.toString()}
                />
              )}
            />
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6}>
            <Controller
              name="email"
              control={control}
              render={({ field: { onChange, value } }) => (
                <DosenInput
                  label="Email *"
                  type="text"
                  placeholder="john.smith@gmail.com"
                  onChange={onChange}
                  error={checkError('email')}
                  helperText={getError('email')?.toString()}
                  value={value || ''}
                  disabled={type !== 'Add'}
                  fullWidth
                />
              )}
            />
          </Grid>

          {/* Program role */}
          <Grid item xs={6}>
            <Controller
              name="role"
              control={control}
              defaultValue=""
              render={({ field: { onChange, value } }) => {
                const selectedRoleOption = roleDropdownOptions.find((option: any) => option.value === value) || null;
                return (
                  <Box>
                    <DosenAutocomplete
                      label="Program role *"
                      options={roleDropdownOptions}
                      value={selectedRoleOption}
                      onChange={(_: any, option: any) => {
                        onChange(option?.value ?? '');
                      }}
                      getOptionLabel={(option: any) => option?.label ?? ''}
                      placeholder="Choose role"
                      sx={{ width: '100%' }}
                    />
                    <FormHelperText error>{getError('role')?.toString()}</FormHelperText>
                  </Box>
                );
              }}
            />
          </Grid>

          {/* Mentorship Match */}
          {/* <Grid item xs={12}>
            <InputLabel>Mentorship Match *</InputLabel>
            <Controller
              name="mentorshipMatch"
              control={control}
              defaultValue={[]}
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  multiple
                  options={['']}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  value={value || []}
                  onChange={(_, newValue) => onChange(newValue)}
                  disableCloseOnSelect
                  renderInput={(params) => (
                    <TextField {...params} fullWidth placeholder="Select Mentors" />
                  )}
                />
              )}
            />
          </Grid> */}

          {/* Select Group */}
        </Grid>

        {/* 19Dec/2023: New Group List */}
        {selectedGroups.length > 0 && (
          <Box mt={2}>
            {selectedGroups.map((group, index) => (
              <GroupRow
                key={group.id}
                groupId={group.id}
                groupName={group.name}
                groupLogo={group.logo}
                groupEnrolled={group.enrolled}
                isLast={index === selectedGroups.length - 1}
                displayRoles={group.displayRoles}
                settingsUpdate={group.settingsUpdate}
              />
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions style={{ backgroundColor: 'transparent' }}>
        <DosenButton
          onClick={handleSubmit(onSubmit)}
          loading={inviteUserLoading}
          loadingText={type === 'Add' ? 'Adding...' : 'Sending...'}
        >
          {type === 'Add' ? 'Add' : 'Resend Invite'}
        </DosenButton>
      </DialogActions>
    </Dialog>
  );
};

export default InviteUserDialog;
